import React, {Component, forwardRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import {Field, Formik} from 'formik';
import * as Yup from 'yup';
import InputMask from "react-input-mask";
import DatePicker, { registerLocale, setDefaultLocale } from  "react-datepicker";
import ru from 'date-fns/locale/ru';
import {addDays, subHours} from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import Tooltip from '../Tooltip/tooltip'

import {
    setCustomerData,
    setProlongation,
    setGameleadDiscount,
    setGameleadPresent,
    setWidgetDiscount,
    setWidgetPresent,
    setPromocode,
    switchMilleniumClub,
    setResultCard,
    setStudentStatus,
    switchInstallmentDiscount,
    setOrderCode
} from '../../actions/card';
import {openModal, changeTypeOfModal, saveModalInfo} from '../../actions/modals';
import {eventEcommerceDetail, eventSelectCard, eventSendForm} from '../../helpers/analytics';

import './styles/formBlockWhite.scss';
import {Privileges} from "../CardWhite/Privileges";
import {separate} from "../../helpers/separate";
import {urlParam} from "../../helpers/urlParam";
import Cookies from "js-cookie";
import Breadcrumbs from "../Breadcrumbs";

registerLocale('ru', ru)
setDefaultLocale(ru)

class FormBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            agreement: process.env.REACT_APP_NODE_ENV == 'development',
            agreementError: '',
            agreementErrorText: '',
            policy: process.env.REACT_APP_NODE_ENV == 'development',
            policyError: false,
            policyErrorText: '',
            mailing: process.env.REACT_APP_NODE_ENV == 'development',
            mailingError: false,
            mailingErrorText: '',
            callConsent: process.env.REACT_APP_NODE_ENV == 'development',
            callConsentError: false,
            callConsentErrorText: '',
            oferta: process.env.REACT_APP_NODE_ENV == 'development',
            ofertaError: false,
            ofertaErrorText: '',
            studentConfirm: false,
            studentConfirmError: false,
            studentConfirmErrorText: '',
            activationDateRequired: false,
            secondActivationDateRequired: false,
            secondCardIsTeen: false,
            sendLoading: false,
            discountCode: '',
            showCodeNotFound: false,
            phoneChecked: false,
            referalCodeInstalled: false
        }
    }

    handleAgreementPolicy() {
        this.setState({
            policy: !this.state.policy
        }, () => {
            this.checkValidAgreements('policy');
        })
    }

    handleMailing() {
        this.setState({
            mailing: !this.state.mailing
        }, () => {
            this.checkValidAgreements('mailing');
        })
    }

    handleCallConsent() {
        this.setState({
            callConsent: !this.state.callConsent
        }, () => {
            this.checkValidAgreements('callConsent');
        })
    }

    handleAgreementProcessData() {
        this.setState({
            agreement: !this.state.agreement
        }, () => {
            this.checkValidAgreements('agreement');
        })
    }

    handleAgreementOferta() {
        this.setState({
            oferta: !this.state.oferta
        }, () => {
            this.checkValidAgreements('oferta');
        })
    }

    handleConfirmStudent() {
        this.setState({
            studentConfirm: !this.state.studentConfirm
        }, () => {
            this.checkValidAgreements('student');
        })
    }

    checkValidAgreements(type) {
        if (type === 'policy') {
            if (!this.state.policy) {
                this.setState({
                    policyError: true,
                    policyErrorText: 'Необходимо согласиться'
                })
            } else {
                this.setState({
                    policyError: false,
                    policyErrorText: ''
                })
            }
        } else if (type === 'oferta') {
            if (!this.state.oferta) {
                this.setState({
                    ofertaError: true,
                    ofertaErrorText: 'Необходимо согласиться'
                })
            } else {
                this.setState({
                    ofertaError: false,
                    ofertaErrorText: ''
                })
            }
        }  else if (type === 'agreement') {
            if (!this.state.agreement) {
                this.setState({
                    agreementError: true,
                    agreementErrorText: 'Необходимо согласиться'
                })
            } else {
                this.setState({
                    agreementError: false,
                    agreementErrorText: ''
                })
            }
        } else if (type === 'student') {
            if (this.props.studentStatus && this.props.resultCard.student_discount && !this.state.studentConfirm) {
                this.setState({
                    studentConfirmError: true,
                    studentConfirmErrorText: 'Необходимо подтвердить'
                })
            } else {
                this.setState({
                    studentConfirmError: false,
                    studentConfirmErrorText: ''
                })
            }
        } else if (type === 'callConsent') {
            if (!this.state.callConsent) {
                this.setState({
                    callConsentError: true,
                    callConsentErrorText: 'Необходимо согласиться'
                })
            } else {
                this.setState({
                    callConsentError: false,
                    callConsentErrorText: ''
                })
            }
        }
    }

    handleSubmit(values, actions) {
        this.setState({
            sendLoading: true,
        });

        if (!this.state.agreement || !this.state.policy || !this.state.oferta || !this.state.callConsent || (this.props.studentStatus && this.props.resultCard.student_discount && !this.state.studentConfirm)) {
            this.checkValidAgreements('agreement')
            this.checkValidAgreements('policy');
            this.checkValidAgreements('callConsent');
            this.checkValidAgreements('mailing');
            this.checkValidAgreements('oferta');
            this.checkValidAgreements('student');
            this.setState({
                sendLoading: false,
            });
            actions.setSubmitting(false);
            return false;
        }

        if (!this.props.resultCard.test_drive && !this.props.resultCard.youth && !this.checkMinAge(values.birthDate, 18)) {
            this.setState({
                sendLoading: false,
            });
            actions.setSubmitting(false);

            this.props.changeTypeOfModal('errorAge')
            this.props.saveModalInfo({type: 'default'})
            this.props.openModal()

            return false;
        }

        if (this.props.resultCard.test_drive && !this.checkMinAge(values.birthDate, 15)) {
            this.setState({
                sendLoading: false,
            });
            actions.setSubmitting(false);

            this.props.changeTypeOfModal('errorAge')
            this.props.saveModalInfo({type: 'testdrive'})
            this.props.openModal()

            return false;
        }

        if (this.props.resultCard.youth && (!this.checkMinAge(values.birthDate, 15) || this.checkMinAge(values.birthDate, 19))) {
            this.setState({
                sendLoading: false,
            });
            actions.setSubmitting(false);

            this.props.changeTypeOfModal('errorAge')
            this.props.saveModalInfo({type: 'youth'})
            this.props.openModal()

            return false;
        }

        if (this.props.studentStatus && this.props.resultCard.student_discount && this.checkMinAge(values.birthDate, 25)) {
            this.setState({
                sendLoading: false,
            });
            actions.setSubmitting(false);

            this.props.changeTypeOfModal('errorAge')
            this.props.saveModalInfo({type: 'student'})
            this.props.openModal()

            return false;
        }

        actions.setSubmitting(true);

        const agreements = {
            process_data_agreement: this.state.agreement,
            privacy_policy_and_user_agreement: this.state.policy,
            contact_with_call_or_sms: this.state.callConsent,
            oferta_and_club_rules: this.state.oferta,
            advertising_and_information_mailing: this.state.mailing
        };

        this.props.setCustomerData(Object.assign({}, values, {agreements: agreements}));

        const self = this;

        //Тут получаем данные о клиенте и проверяем, не покупал ли он ранее пробный день
        axios.post(`${process.env.REACT_APP_FITRON_URL}/contragentrequest`, {
            'phone': values.phone,
            'tariff': self.props.resultCard.title,
            'subscription': self.props.resultCard.subscription,
            'test_drive': self.props.resultCard.test_drive,
            'test_drive_price': self.basePrice(self.props.resultCard),
            'send_lead': process.env.REACT_APP_NODE_ENV === "production",
            'name': values.name,
            //'surname': values.surname,
            'email': values.email,
            'contact_method': values.contact_method,
            'nickname': values.nickname,
            'club': values.club,
            'utm': window.location.href,
            'utm_source': sessionStorage.getItem('utm_source'),
            'utm_campaign': sessionStorage.getItem('utm_campaign'),
            'utm_medium': sessionStorage.getItem('utm_medium'),
            'utm_term': sessionStorage.getItem('utm_term'),
            'utm_content': sessionStorage.getItem('utm_content'),
            'utm_company': sessionStorage.getItem('utm_company'),
            'roistat_visit': Cookies.get('roistat_visit'),
            'agreements': agreements
        }, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (!response.data.has_active_contract && !values.activationDate) {
                    self.setState({
                        activationDateRequired: !response.data.has_active_contract
                    });
                    this.setState({
                        sendLoading: false,
                    });
                    actions.setSubmitting(false);
                    return false;
                }

                if (response.data.test_drive_error || (this.props.resultCard.test_drive && response.data.has_active_contract_in_club)) {
                    actions.setSubmitting(false);
                    actions.resetForm();
                    self.setState({
                        sendLoading: false,
                    });
                    localStorage.setItem('phone', values.phone);
                    localStorage.setItem('club', values.club);
                    localStorage.setItem('name', values.name);
                    localStorage.setItem('email', values.email);
                    localStorage.setItem('agreements', agreements);
                    localStorage.setItem('hasActiveContract', response.data.has_active_contract_in_club ? 1 : 0)
                    localStorage.setItem('hadContract', response.data.had_contract ? 1 : 0)
                    self.props.history.push('/finish?result=testdriveerror');
                    return false;
                }

                if (this.props.resultCard.subscription && (response.data.has_active_non_subscription_contract || response.data.has_active_subscription)) {
                    actions.setSubmitting(false);
                    actions.resetForm();
                    self.setState({
                        sendLoading: false,
                    });
                    localStorage.setItem('phone', values.phone);
                    localStorage.setItem('club', values.club);
                    localStorage.setItem('name', values.name);
                    localStorage.setItem('email', values.email);
                    localStorage.setItem('agreements', agreements);
                    localStorage.setItem('hasActiveContract', response.data.has_active_non_subscription_contract ? 1 : 0)
                    localStorage.setItem('hasActiveSubscription', response.data.has_active_subscription ? 1 : 0)
                    self.props.history.push('/finish?result=subscription-error');
                    return false;
                }

                eventSendForm({
                    id: self.props.resultCard.id,
                    title: self.props.resultCard.title,
                    price: self.basePrice(self.props.resultCard)
                });
                self.props.setProlongation(response.data.prolong, response.data.prolongation_discount);

                const gameleadDiscount = self.props.resultCard.gamelead && self.props.resultCard.gamelead_type == 'discount' ? response.data.gamelead_discount : 0,
                  gameleadPresent = self.props.resultCard.gamelead && self.props.resultCard.gamelead_type == 'present' ? response.data.gamelead_present : ''

                self.props.setGameleadDiscount(gameleadDiscount)
                self.props.setGameleadPresent(gameleadPresent)

                const widgetDiscount = self.props.resultCard.apply_widget_discount && response.data.widget_discount ? response.data.widget_discount : 0,
                    widgetPresent = self.props.resultCard.apply_widget_discount && response.data.widget_present ? response.data.widget_present : null;

                self.props.setWidgetDiscount(widgetDiscount);
                self.props.setWidgetPresent(widgetPresent);

                self.saveOrder(response.data, gameleadDiscount, gameleadPresent, widgetDiscount, widgetPresent).then(response => {
                    actions.setSubmitting(false);
                    self.setState({
                        sendLoading: false,
                    });
                    if (response.data.success && response.data.data.hasOwnProperty('code')) {
                        actions.resetForm();

                        self.props.setOrderCode(response.data.data.code)

                        if (self.props.resultCard.subscription) {
                            self.props.changeStep(4);
                        } else {
                            self.props.history.push('/order/' + response.data.data.code);
                        }
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            }
        }).catch(function (error) {
            console.log('error', error);
            actions.setSubmitting(false);
            actions.resetForm();
            self.setState({
                sendLoading: false,
            });
            self.props.history.push('/finish?result=error');
        });
    }

    saveOrder(data, gameleadDiscount, gameleadPresent, widgetDiscount, widgetPresent) {
        const self = this

        return axios.post(`${process.env.REACT_APP_API_SITE}/save-order`, {
            phone: self.props.customerData.phone.replaceAll(/[^0-9]*/g, ''),
            tariff_id: self.props.resultCard.id,
            data: {
                prolongation: data.prolongation,
                prolongationDiscount: data.prolongation_discount,
                installmentDiscount: self.props.installmentDiscount,
                studentStatus: self.props.studentStatus,
                promocode: self.props.promocode,
                milleniumAdded: self.props.milleniumAdded && self.props.resultCard.millenium_add_available,
                gameleadDiscount: gameleadDiscount,
                gameleadPresent: gameleadPresent,
                widgetDiscount: widgetDiscount,
                widgetPresent: widgetPresent,
                customerData: self.props.customerData,
            }
        }, {
            headers: {
                'Content-type': 'application/json',
            }
        })
    }

    goToPrevScreen() {
        this.props.history.push('/')
        this.props.backStep(1)
    }

    componentDidMount() {
        if (!this.props.resultCard && !this.props.params.tariff) {
            this.props.history.push('/')
        }

        if (this.props.resultCard) {
            eventEcommerceDetail({
                id: this.props.resultCard.id,
                title: this.props.resultCard.title,
                price: this.basePrice(this.props.resultCard)
            })
        }

        if (this.props.promocode) {
            this.checkPromocode(this.props.customerData ? this.props.customerData.phone : '', this.props.promocode.code)
        }

        if (this.props.customerData && this.props.customerData.hasOwnProperty('phone')) {
            this.checkPhone(this.props.customerData.phone, true)
        }

        if (this.props.customerData && this.props.customerData.hasOwnProperty('secondPhone')) {
            this.checkPhone(this.props.customerData.secondPhone, true, true)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.mainData.hasOwnProperty('cards') && this.props.mainData.hasOwnProperty('cards') && !this.props.resultCard) {
            if (this.props.params.tariff) {
                const card = this.props.mainData.cards.find(card => card.slug === this.props.params.tariff)
                //this.props.eventSelectCard(card);
                this.props.setResultCard(card);

                const milleniumParam = urlParam('millenium');
                if (milleniumParam) {
                    this.props.switchMilleniumClub(milleniumParam == 1);
                }

                const insDiscountParam = urlParam('insdiscount')
                if (insDiscountParam) {
                    this.props.switchInstallmentDiscount(insDiscountParam == 1)
                }

                const clubInstallmentParam = urlParam('clubinstallment')
                if (clubInstallmentParam) {
                    this.props.switchInstallmentDiscount(clubInstallmentParam != 1)
                }

                const studentParam = urlParam('student')
                if (studentParam) {
                    this.props.setStudentStatus(studentParam == 1)
                    this.props.switchInstallmentDiscount(false)
                }
            } else {
                this.props.history.push('/')
            }
        }
        if (this.props.resultCard && !this.state.referalCodeInstalled) {
            const referalCodeParam = urlParam('r')
            if (referalCodeParam) {
                this.setState({referalCodeInstalled: true})
                this.checkPromocode(this.props.customerData ? this.props.customerData.phone : '', referalCodeParam)
            }
        }
    }

    calculateOneMonth(data) {
        let cost;

        data.cost_month.forEach(item => {
            if (this.props.duration >= item.minMonth && this.props.duration <= item.maxMonth) {
                cost = item.cost;
            }
        })

        if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_price) {
            cost += data.millenium_add_price
        }

        return cost;
    }

    calculateOneMonthFreezing(data) {
        let cost = data.cost_freezing;

        if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_price_freezing) {
            cost += data.millenium_add_price_freezing
        }

        return cost;
    }

    calculateDiscount(data) {
        let discount;

        data.forEach(item => {
            if (this.props.duration >= item.minMonth && this.props.duration <= item.maxMonth) {
                discount = item.discount;
            }
        })

        return discount;
    }

    perUnitPrice(data) {
        return data.visit_count_fixed && data.show_cost_fixed && data.cost_fixed
            ? data.cost_fixed + (this.props.milleniumAdded ? data.millenium_add_fixed_price : 0)
            : data.cost_month_base + ( this.props.milleniumAdded ? data.millenium_add_price : 0)
    }

    basePrice(data) {
        if (data.subscription) {
            let totalCost = data.subscription_cost_first_month
            if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_first_month_price) {
                totalCost += data.millenium_add_first_month_price
            }
            return totalCost
        } else if (data.test_drive) {
            return data.cost_fixed
        } else if (data.cost_fixed && data.visit_count_fixed) {
            return (data.cost_fixed + (this.props.milleniumAdded ? data.millenium_add_fixed_price : 0)) * data.visit_count_fixed;
        } else {
            let monthCost = +this.calculateOneMonth(data) * this.props.duration;
            let freezingCost = +this.calculateOneMonthFreezing(data) * this.props.freezing;
            let totalCost = monthCost + freezingCost

            if (this.props.resultCard.family) {
                if (this.state.secondCardIsTeen) {
                    let teenCardData = {
                        cost_month: [{
                            cost: data.teen_card_cost_month,
                            maxMonth: 999,
                            minMonth: 0
                        }],
                        millenium_add_price: data.teen_card_club_add_cost_month,
                        cost_freezing: data.teen_card_cost_freezing,
                        millenium_add_price_freezing: data.teen_card_club_add_cost_freezing
                    }

                    totalCost = totalCost
                      + this.calculateOneMonth(teenCardData) * data.teen_card_base_months
                      + this.calculateOneMonthFreezing(teenCardData) * data.teen_card_base_freezing_months
                } else {
                    totalCost = totalCost * 2
                }
            }

            return totalCost;
        }
    }

    finalPrice(data, promocode) {
        let basePrice = this.basePrice(data),
          result = basePrice;

        if (!data.subscription && !data.test_drive) {
            if (this.props.gameleadDiscount) {
                result -= result * parseInt(this.props.gameleadDiscount) / 100
            } else if (this.props.widgetDiscount) {
                result -= result * parseInt(this.props.widgetDiscount) / 100
            } else {
                const availableInstallments = data.installments.filter(installment => installment.for_new)

                let discount = 0
                if (this.props.installmentDiscount && availableInstallments.length > 0 && availableInstallments[0].markup_new > 0) {
                    discount = availableInstallments[0].markup_new
                } else if (this.props.mainData) {
                    if (this.props.studentStatus) {
                        discount = data.student_discount
                    } else if (this.props.dayDiscount) {
                        discount = this.calculateDiscount(this.props.mainData.discounts.day)
                    }
                }

                if (discount === 0 && this.props.resultCard.unconditional_discount && (!this.props.prolongation || !this.props.resultCard.prolongation_discount)) {
                    discount = this.props.resultCard.unconditional_discount
                }

                if (discount > 0) {
                    result -= result * discount / 100
                }

                if (this.props.prolongation
                  && this.props.resultCard.prolongation_discount
                  && this.props.prolongationDiscount > 0
                  && this.props.duration > 1
                  && !(this.props.studentStatus && data.student_discount > 0)
                ) {
                    result -= result * this.props.prolongationDiscount / 100
                }
            }
        }

        if (promocode) {
            if (promocode.discount > 100) {
                result -= promocode.discount;
            } else {
                result -= result * promocode.discount / 100;
            }
        }

        return result
    }

    appliedDiscounts(data, promocode) {
        let result = [];

        if (!data.subscription && !data.test_drive) {
            if (this.props.gameleadDiscount) {
                result.push('-' + this.props.gameleadDiscount + '% из колеса фортуны')
            } else if (this.props.widgetDiscount) {
                result.push('-' + this.props.widgetDiscount + '% из виджета')
            } else {
                const availableInstallments = data.installments.filter(installment => installment.for_new)

                if (this.props.installmentDiscount && availableInstallments.length > 0 && availableInstallments[0].markup_new > 0) {
                    result.push('-' + availableInstallments[0].markup_new + '% при оплате полной стоимости')
                } else if (this.props.studentStatus && data.student_discount > 0) {
                    result.push('-' + data.student_discount + '% студентам')
                } else if (this.props.mainData && this.props.dayDiscount) {
                    result.push('-' + this.calculateDiscount(this.props.mainData.discounts.day) + '% дневная')
                } else if (this.props.resultCard.unconditional_discount && (!this.props.prolongation || !this.props.resultCard.prolongation_discount)) {
                    result.push('-' + this.props.resultCard.unconditional_discount + '% при покупке онлайн')
                }

                if (this.props.prolongation
                  && this.props.duration > 1
                  && this.props.prolongationDiscount > 0
                  && this.props.resultCard.prolongation_discount
                  && !(this.props.studentStatus && data.student_discount > 0)
                ) {
                    result.push('-' + this.props.prolongationDiscount + '% за продление')
                }
            }
        }

        if (promocode) {
            if (promocode.discount > 100) {
                result.push('-' + promocode.discount + 'р по промокоду ' + promocode.code)
            } else {
                result.push('-' + promocode.discount + '% по промокоду ' + promocode.code)
            }
        }

        return result
    }

    checkPhone(phone, isValid, isSecond = false) {
        let self = this

        if (isValid) {
            axios.post(`${process.env.REACT_APP_FITRON_URL}/contragentrequest`, {
                'phone': phone,
            }, {
                headers: {
                    'Content-type': 'application/json',
                }
            }).then((response) => {
                // console.log('response', response);
                if (response.status === 200) {
                    self.setState({phoneChecked: true})
                    if (isSecond) {
                        self.setState({
                            secondActivationDateRequired: !response.data.has_active_contract
                        });
                    } else {
                        self.setState({
                            activationDateRequired: !response.data.has_active_contract
                        });

                        self.props.setProlongation(response.data.prolong, response.data.prolongation_discount);
                        self.props.setGameleadDiscount(self.props.resultCard.gamelead && self.props.resultCard.gamelead_type == 'discount' ? response.data.gamelead_discount : 0)
                        self.props.setGameleadPresent(self.props.resultCard.gamelead && self.props.resultCard.gamelead_type == 'present' ? response.data.gamelead_present : '')
                        self.props.setWidgetDiscount(self.props.resultCard.apply_widget_discount && response.data.widget_discount ? response.data.widget_discount : 0)
                        self.props.setWidgetPresent(self.props.resultCard.apply_widget_discount && response.data.widget_present ? response.data.widget_present : '')
                        if (self.props.promocode) {
                            self.checkPromocode(phone, self.props.promocode.code, response.data.prolong, response.data.prolongation_discount)
                        }
                    }
                }
            })
        }
    }

    checkPromocode(phone, code, prolongation = null, prolongationDiscount = null) {
        if (code == '') {
            this.props.setPromocode(null)
            return;
        }

        if (prolongation === null) {
            prolongation = this.props.prolongation
        }

        if (prolongationDiscount === null) {
            prolongationDiscount = this.props.prolongationDiscount
        }

        let self = this,
          data = {
              phone: phone,
              code: code,
              card: this.props.resultCard.title,
              prolongation: prolongation && this.props.resultCard.prolongation_discount && prolongationDiscount > 0,
              family: this.props.resultCard.family,
              student: this.props.studentStatus,
              day: this.props.dayDiscount,
              referalDiscount: this.props.resultCard.referal_discount,
              baseMonths: this.props.resultCard.base_months
          }

        self.setState({
            sendLoading: true,
            showCodeNotFound: false
        });

        axios.post(`${process.env.REACT_APP_API_SITE}/check-promocode`, data, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (response.data.error) {
                    self.setState({
                        sendLoading: false,
                    });
                    //self.props.history.push('/finish?result=error');
                    return false;
                }

                if (response.data) {
                    self.setState({
                        sendLoading: false,
                    });

                    if (response.data.available) {
                        self.props.setPromocode({
                            'code': code,
                            'discount': response.data.discount,
                            'present': response.data.present
                        })
                    } else {
                        self.props.setPromocode(null)
                        self.setState({showCodeNotFound: true})
                    }
                }
            }
        }).catch(function (error) {
            // console.log('error', error.response);
            self.setState({
                sendLoading: false,
            });
        });
    }

    clearPromocode() {
        if (window.confirm('Отменить промокод?')) {
            this.setDiscountCode('')
            this.props.setPromocode(null)
        }
    }

    setDiscountCode(code) {
        this.setState({discountCode: code, showCodeNotFound: false})
    }

    getDateFromString(birthDateString) {
        const birthDateArr = birthDateString.split('.')

        return new Date(birthDateArr[2], birthDateArr[1]-1, birthDateArr[0])
    }

    calculateAge(birthDateString) {
        const birthDate = this.getDateFromString(birthDateString),
          nowDate = new Date()

        return (nowDate - birthDate)/1000/60/60/24/365.2425
    }

    checkMinAge(birthDateString, minAge) {
        return this.calculateAge(birthDateString) >= minAge
    }

    render() {

        const {
            resultCard,
            customerData,
            studentStatus,
            dayDiscount,
            prolongation,
            prolongationDiscount,
            installmentDiscount,
            promocode,
            gameleadDiscount,
            widgetDiscount,
            milleniumAdded,
            changeTypeOfModal,
            openModal,
            mainData,
        } = this.props;

        const hasDiscount = resultCard && this.appliedDiscounts(resultCard, promocode).length > 0

        const options = {
            wheelSpeed: 1,
            maxScrollbarLength: 132
        };

        const clubsAddresses = {
            gazetniy: "Газетный / Красноармейская, 170",
            gorizont: "Горизонт / М. Нагибина, 32е",
            orbita: "Орбита / Королева, 10/4",
            millenium: "Миллениум / Соборный, 94г",
        }

        /*
        const clubOptions = Object.keys(resultCard.clubs).filter(club => resultCard.clubs[club]).map(club => {
            return {
                value: club,
                label: clubsAddresses[club]
            }
        })

        if (!resultCard.clubs.millenium && milleniumAdded) {
            clubOptions.push({
                value: 'millenium',
                label: clubsAddresses.millenium
            })
        }
        */

        //Вариант, когда выбор клуба не зависит от наполнения карты
        const clubOptions = Object.keys(clubsAddresses).map(club => {
            return {
                value: club,
                label: clubsAddresses[club]
            }
        })

        const contactMethods = [
            {
                value: 'call',
                label: 'Звонок'
            },
            {
                value: 'whatsapp',
                label: 'WhatsApp'
            },
            {
                value: 'telegram',
                label: 'Telegram'
            },
            {
                value: 'max',
                label: 'Max'
            }
        ]

        let self = this,
          validationRules = {
            name: Yup.string()
                .trim()
                .required('Введите ФИО')
                .matches(/^\S+ \S+[\s\S]*$/, 'Введите Фамилию, Имя и Отчество (при наличии)'),
            //surname: Yup.string()
            //    .trim()
            //    .required('Введите Фамилию'),
            //patronymic: Yup.string()
            //    .required('Введите Отчество'),
            birthDate: Yup.string()
                .trim()
                .required('Введите дату рождения')
                .min(10, 'Некорректная дата')
                .test(
                  'age-valid-date',
                  'Некорректная дата',
                  function(v) {
                      const birthDate = self.getDateFromString(v),
                        birthDateArr = v.split('.')
                      return birthDate.getFullYear() === parseInt(birthDateArr[2])
                        && birthDate.getMonth() === birthDateArr[1] - 1
                        && birthDate.getDate() === parseInt(birthDateArr[0])
                  }
                ),
            email: Yup.string()
                .trim()
                .email('Некорректный email')
                .required('Введите email'),
            phone: Yup.string()
                .trim()
                .required('Введите номер телефона')
                .min(16, 'Некорректный номер телефона'),
            club: Yup.string()
                .required('Выберите адрес'),
            contact_method: Yup.string()
                .required('Выберите предпочитаемый способ связи'),
            nickname: Yup.string()
                .when('contact_method', {
                      is: (contact_method) => ['telegram', 'max'].includes(contact_method),
                      then: (schema) => schema.required('Укажите свой ник для связи')
                })
        }

        if (resultCard && resultCard.test_drive) {
            validationRules.withTrainer = Yup.number().required('Выберите один из вариантов')
            validationRules.visitTime = Yup.number().required('Выберите один из вариантов')
        }

        if (resultCard && resultCard.slug == 'light') {
            validationRules.sex = Yup.string().required('Выберите пол')
        }

        if (this.state.activationDateRequired) {
            validationRules.activationDate = Yup.date().required('Введите дату начала тренировок')
        }

        if (resultCard && resultCard.family) {
            validationRules.birthDate = validationRules.birthDate.test(
              'age-greater-18',
              'Контракт №1 должен быть оформлен на клиента старше 18 лет',
              function(v) {
                  return self.checkMinAge(v, 18);
              }
            )

            //validationRules.secondSurname = Yup.string().trim().required('Введите Фамилию')
            validationRules.secondName = Yup.string().trim().required('Введите ФИО')
              .matches(/^\S+ \S+[\s\S]*$/, 'Введите Фамилию, Имя и Отчество (при наличии)')
              .test(
                  'notequals',
                  'ФИО не должно повторяться',
                  function(v) {
                      const ref = Yup.ref('name');
                      return v !== this.resolve(ref);
                  }
              )
            validationRules.secondBirthDate = Yup.string().trim().required('Введите дату рождения').min(10, 'Некорректная дата').test(
              'age-greater-11',
              'Оформление контракта доступно для клиентов с 11 лет',
              function(v) {
                  return self.checkMinAge(v, 11);
              }
            )
            validationRules.secondEmail = Yup.string().trim().email('Некорректный email').required('Введите email')
            validationRules.secondPhone = Yup.string().trim().required('Введите номер телефона').min(16, 'Некорректный номер телефона').test(
              'notequals',
              'Номер телефона не должен повторяться',
              function(v) {
                  const ref = Yup.ref('phone');
                  return v !== this.resolve(ref);
              }
            )

            if (this.state.secondActivationDateRequired) {
                validationRules.secondActivationDate = Yup.date().required('Введите дату начала тренировок')
            }
        }

        const schema = Yup.object().shape(validationRules);

        const CalendarCustomInput = forwardRef(({ value, onClick, onChange, className }, ref) => (
            <label>
                <input
                    type="text"
                    value={value}
                    className={'calendar-input ' + className}
                    onClick={onClick}
                    onChange={onChange}
                    ref={ref}
                ></input>
                <span className="icon"></span>
            </label>
        ));

        let fieldsFlag = true;

        return (
            <div>
                <div className="container">
                    {
                        mainData && resultCard ?
                            <div className="client-form-block">
                                <div className="client-form-block__header">
                                    <Breadcrumbs currentItem={1} goBackHandle={this.goToPrevScreen.bind(this)}/>
                                </div>
                                <div className="client-form-block__body" ref={(ref) => this.ref = ref}>
                                    <div className="client-form-block__body__form">
                                        <Formik
                                            initialValues={{
                                                ///surname: customerData?.surname,
                                                name: customerData ? customerData.name : (process.env.REACT_APP_NODE_ENV == 'development' ? 'Тестов Тест' : ''),
                                                //patronymic: '',
                                                birthDate: customerData ? customerData.birthDate : (process.env.REACT_APP_NODE_ENV == 'development' ? '10.10.2000' : ''),
                                                email: customerData ? customerData.email : (process.env.REACT_APP_NODE_ENV == 'development' ? 'test@test.te' : ''),
                                                phone: customerData ? customerData.phone : '',
                                                contact_method: customerData ? customerData.contact_method : '',
                                                nickname: customerData ? customerData.nickname : '',
                                                activationDate: customerData ? customerData.activationDate : new Date(),
                                                sex: customerData ? customerData.sex : '',
                                                club: customerData ? customerData.club : '',
                                                //secondSurname: '',
                                                secondName: customerData ? customerData.secondName : '',
                                                secondBirthDate: customerData ? customerData.secondBirthDate : '',
                                                secondEmail: customerData ? customerData.secondEmail : '',
                                                secondPhone: customerData ? customerData.secondPhone : '',
                                                secondActivationDate: customerData ? customerData.secondActivationDate : new Date(),
                                                withTrainer: customerData ? customerData.withTrainer : '',
                                                visitTime: customerData ? customerData.visitTime : '',
                                                agreement: process.env.REACT_APP_NODE_ENV == 'development',
                                                policy: process.env.REACT_APP_NODE_ENV == 'development',
                                                oferta: process.env.REACT_APP_NODE_ENV == 'development',
                                                mailing: process.env.REACT_APP_NODE_ENV == 'development',
                                                callConsent: process.env.REACT_APP_NODE_ENV == 'development',
                                                studentConfirm: false
                                            }}
                                            validate={(values) => {
                                                if (
                                                    !values.name
                                                    //&& !values.surname
                                                    && !values.patronymic
                                                    && !values.birthDate
                                                    && !values.email
                                                    && !values.phone
                                                    && !values.contact_method
                                                    && !values.activationDate
                                                    && !values.sex
                                                    && !values.club
                                                    && !values.agreement
                                                    && !values.policy
                                                    && !values.oferta
                                                    && !values.mailing
                                                    && !values.callConsent
                                                ) {
                                                    window.scrollTo({top: this.ref.offsetTop - 200, behavior: "smooth"});
                                                }

                                                if(fieldsFlag && window.innerWidth < 992) {
                                                    setTimeout(()=>{
                                                        if(document.querySelector('._error-field')) {
                                                            document.querySelector('.clientForm__user-data').scrollIntoView({
                                                                behavior: "smooth",
                                                                block: "start"
                                                              });
                                                        }
                                                        fieldsFlag = false
                                                    },100)
                                                }
                                            }}
                                            validationSchema={schema}
                                            onSubmit={(values, actions) => {
                                                this.setState({
                                                    sendLoading: true,
                                                });
                                                this.handleSubmit(values, actions);
                                            }}
                                        >
                                            {props => (
                                              <form onSubmit={props.handleSubmit} className={`clientForm`}>

                                                  <div className="clientForm__info">
                                                      <div
                                                        className={'card-title ' + resultCard.header_class}>{resultCard.title}</div>
                                                      <div className="card-duration">
                                                          {resultCard.test_drive ? '1 день' : (
                                                            <div>
                                                                {resultCard.visit_count_fixed &&
                                                                  <p>{separate(Math.round(resultCard.visit_count_fixed))} посещени{String(resultCard.visit_count_fixed).endsWith(1) ? 'е' : ('234'.includes(String(resultCard.visit_count_fixed).substr(-1, 1)) ? 'я' : 'й')}</p>
                                                                }
                                                                <p>
                                                                    {separate(Math.round(resultCard.base_months))} месяц{resultCard.base_months > 4 ? 'ев' : (resultCard.base_months > 1 ? 'а' : '')}
                                                                    {resultCard.subscription ? <Tooltip
                                                                      text="Абонемент с оплатой раз в месяц. Посещайте выбранный клуб с мультидоступом ещё в три клуба. По расходам на физкультурно-оздоровительные услуги налогоплательщику предоставляется социальный вычет в размере 13%"/> : ''}
                                                                </p>
                                                                {resultCard.subscription ?
                                                                  <p className="automatic-renew-comment">Автоматическое
                                                                      продление <Tooltip
                                                                        text="Автоматические платежи с банковской карты всегда можно отменить."/>
                                                                  </p> : ''}
                                                                {resultCard.subscription ? <p>1 гостевой визит в месяц</p> : ''}
                                                                {resultCard.base_freezing_months > 0 ?
                                                                  <p>+{resultCard.base_freezing_months * 30} дней
                                                                      заморозки</p> : ''}
                                                                {resultCard.comfort ? <p className='comfort-tip'>
                                                                    <b>Время посещения ограничено</b>
                                                                    <br/><br/>Доступ в клуб в будние дни:
                                                                    <ul style={{paddingLeft: '15px', marginTop: '5px'}}>
                                                                        <li>с 7:00 до 17:00 (FITRON Газетный с 6:00 до
                                                                            17:00)
                                                                        </li>
                                                                        <li>с 21:00 до 23:00</li>
                                                                    </ul>
                                                                    <br/>Выходные и праздничные дни без ограничений
                                                                </p> : ''}
                                                                {resultCard.slug == 'love' ? <p style={{fontSize: '12px'}}>Для оформления подарочной карты обратитесь к своему менеджеру</p> : ''}
                                                                {
                                                                    resultCard.youth
                                                                        ? <p className='comfort-tip'>
                                                                            <b>Только для клиентов возрастом от 15 до 18 лет</b>
                                                                            <br/><br/><b>Время посещения ограничено</b>
                                                                            <br/>Доступ в клуб с 7:00 до 17:00
                                                                            <br/>(FITRON Газетный с 6:00 до 17:00)
                                                                        </p>
                                                                        : ''
                                                                }
                                                            </div>
                                                          )}
                                                      </div>
                                                      {
                                                          resultCard.title == 'Фестивальный' ? <div className="card-expire">ТОЛЬКО СЕГОДНЯ!</div> : (
                                                            resultCard.expires ? <div className="card-expire">Предложение действует до {resultCard.expires}</div> : ''
                                                          )
                                                      }
                                                      {
                                                          resultCard.slug == 'sale' ?
                                                            (
                                                              props.values.phone && props.values.phone.length > 15 && this.state.phoneChecked ?
                                                                  (
                                                                      gameleadDiscount || widgetDiscount ?
                                                                          <div className="price-wrapper">
                                                                              <div className="total-price">
                                                                                  <span
                                                                                      className={`price-value ${(hasDiscount ? 'striped' : '')}`}>
                                                                                      <span
                                                                                          className="amount">{separate(Math.ceil(this.basePrice(resultCard)))}</span> ₽</span>
                                                                                  <div className="total-description">Полная стоимость</div>
                                                                              </div>
                                                                              <div className="discount">Ваша скидка {gameleadDiscount || widgetDiscount}%</div>
                                                                              <div className="monthly-price">
                                                                                  <div className="price-number">
                                                                                        <span
                                                                                            className="amount">{`${separate(Math.ceil(
                                                                                            this.finalPrice(resultCard, promocode)
                                                                                        ))}`}</span> ₽
                                                                                  </div>
                                                                                  <div className="price-description">Со скидкой
                                                                                      <br/><span style={{color: 'red'}}
                                                                                                 dangerouslySetInnerHTML={{__html: this.appliedDiscounts(resultCard, promocode).join('<br/>')}}></span>
                                                                                  </div>
                                                                              </div>
                                                                          </div>
                                                                          : <div className="price-wrapper">
                                                                              <div style={{
                                                                                  fontSize: '16px',
                                                                                  fontWeight: 700,
                                                                                  color: 'red'
                                                                              }}>{resultCard.widget_discount_text ?? "Покрутите колесо на предыдущем шаге для получения скидки"}</div>
                                                                          </div>
                                                                  ) : ''
                                                            ) :
                                                              (
                                                                  resultCard.test_drive ?
                                                                      <div className="price-wrapper">
                                                                        <div className="monthly-price">
                                                                              <div className="price-number">
                                                                                  <span
                                                                                      className="amount">{`${separate(Math.ceil(resultCard.cost_fixed))}`}</span> ₽
                                                                              </div>
                                                                              <div className="price-description">Абонемент на один день</div>
                                                                            {/*
                                                                              <div className="alert-text">Приобретая тариф Индивидуальный в
                                                                            течение 48 часов после тест-драйва, вы получите
                                                                            скидку 500 руб!
                                                                        </div>*/}
                                                                    </div>
                                                                </div> :
                                                                (
                                                                  resultCard.subscription ?
                                                                    <div className="price-wrapper">
                                                                        {
                                                                            hasDiscount ?
                                                                                <div className="monthly-price">
                                                                                    <div className="price-number">
                                                                                    <span
                                                                                        className="amount">{`${separate(Math.ceil(
                                                                                        this.finalPrice(resultCard, promocode)
                                                                                    ))}`}</span> ₽
                                                                                    </div>
                                                                                    <div className="price-description">Со скидкой
                                                                                        <br/><span style={{color: 'red'}}
                                                                                                          dangerouslySetInnerHTML={{__html: this.appliedDiscounts(resultCard, promocode).join('<br/>')}}></span>
                                                                                    </div>
                                                                                </div> :
                                                                                <div className="monthly-price">
                                                                                    <div className="price-number">
                                                                                        <span className="amount">{`${separate(Math.ceil(
                                                                                            this.basePrice(resultCard)
                                                                                        ))}`}</span> ₽
                                                                                    </div>
                                                                                    <div className="price-description">За первый месяц</div>
                                                                                </div>
                                                                        }
                                                                        <div className="total-price">
                                                                            <span
                                                                              className={`price-value`}>
                                                                                <span
                                                                                  className="amount">{separate(Math.ceil(this.perUnitPrice(resultCard)))}</span> ₽
                                                                            </span>
                                                                            <div className="total-description">Со второго
                                                                                месяца
                                                                            </div>
                                                                        </div>
                                                                    </div> :
                                                                    <div className="price-wrapper">
                                                                        {
                                                                            hasDiscount ?
                                                                              <div className="monthly-price">
                                                                                  <div className="price-number">
                                                                                    <span
                                                                                      className="amount">{`${separate(Math.ceil(
                                                                                      this.finalPrice(resultCard, promocode)
                                                                                    ))}`}</span> ₽
                                                                                  </div>
                                                                                  <div className="price-description">Со
                                                                                      скидкой<br/><span style={{color: 'red'}}
                                                                                                        dangerouslySetInnerHTML={{__html: this.appliedDiscounts(resultCard, promocode).join('<br/>')}}></span>
                                                                                  </div>
                                                                              </div> :
                                                                              <div className="monthly-price">
                                                                                  <div className="price-number">
                                                                                    <span
                                                                                      className="amount">{`${separate(Math.ceil(
                                                                                      this.perUnitPrice(resultCard)
                                                                                    ))}`}</span> ₽
                                                                                  </div>
                                                                                  <div className="price-description">Стоимость
                                                                                      одного {resultCard.visit_count_fixed && resultCard.show_cost_fixed ? 'посещения' : 'месяца'}
                                                                                  </div>
                                                                              </div>
                                                                        }
                                                                        {
                                                                            <div className="total-price">
                                                                                    <span
                                                                                        className={`price-value ${(hasDiscount ? 'striped' : '')}`}>
                                                                                        <span
                                                                                            className="amount">{separate(Math.ceil(this.basePrice(resultCard)))}</span> ₽
                                                                                    </span>
                                                                                <div className="total-description">Полная
                                                                                    стоимость
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                )
                                                            )
                                                      }
                                                      {
                                                        this.props.gameleadPresent && this.props.gameleadPresent != ''
                                                          && <div className="present-description">Подарок: {this.props.gameleadPresent}</div>
                                                      }
                                                      {
                                                        this.props.widgetPresent && this.props.widgetPresent != ''
                                                          && <div className="present-description">Подарок: {this.props.widgetPresent}</div>
                                                      }
                                                      <div className="your-offer__clubs">
                                                          <p
                                                            className={resultCard.clubs.gazetniy ? '' : 'your-offer__club-disabled'}>
                                                              <b>Газетный</b> / Красноармейская, 170
                                                          </p>
                                                          <p
                                                            className={resultCard.clubs.gorizont ? '' : 'your-offer__club-disabled'}>
                                                              <b>Горизонт</b> / пр. М. Нагибина, 32е
                                                          </p>
                                                          <p
                                                            className={resultCard.clubs.orbita ? '' : 'your-offer__club-disabled'}>
                                                              <b>Орбита</b> / Королёва, 10/4
                                                          </p>
                                                          {
                                                              resultCard.clubs.millenium || milleniumAdded ?
                                                                <p>
                                                                    <b>Миллениум</b> /
                                                                    Соборный, 94г</p>
                                                                : (resultCard.millenium_add_available ?
                                                                  <div className="add-club">
                                                                    <p><b>Миллениум</b> / Соборный, 94г</p>
                                                                    <button onClick={e => this.props.switchMilleniumClub(true)}>
                                                                        Добавить Миллениум
                                                                    </button>
                                                                  </div> : '')
                                                          }
                                                          {
                                                              !resultCard.clubs.millenium && milleniumAdded ?
                                                                <div>
                                                                    <button className="remove-club-button"
                                                                            onClick={e => this.props.switchMilleniumClub(false)}>
                                                                        Убрать Миллениум
                                                                    </button>
                                                                </div> : ''
                                                          }
                                                      </div>
                                                      {
                                                          (!resultCard.has_promocode && !(resultCard.referal_discount > 0)) ? '' :// || this.props.gameleadDiscount
                                                            <div className="clientForm__item">
                                                                {this.props.promocode ?
                                                                  <div className="promocode-cont promocode-applied">
                                                                      <input type="text" className="promo-code"
                                                                             disabled="disabled"
                                                                             value={this.props.promocode.code}/>
                                                                      <button onClick={e => {
                                                                          e.preventDefault()
                                                                          this.clearPromocode()
                                                                      }} className="button-clear">
                                                                          <img
                                                                            src={require('../../static/images/icons/close.svg').default}
                                                                            alt=""/>
                                                                      </button>
                                                                  </div>
                                                                  :
                                                                  <div className="promocode-cont">
                                                                      <input type="text" className="promo-code"
                                                                             placeholder="Промокод"
                                                                             value={this.state.discountCode}
                                                                             disabled={this.state.sendLoading}
                                                                             onChange={e => {
                                                                                 this.setDiscountCode(e.target.value)
                                                                             }}
                                                                             onBlur={
                                                                                e => {
                                                                                    this.checkPromocode(props.values.phone, e.target.value)
                                                                                }}
                                                                             onKeyUp={
                                                                                 e => {
                                                                                     if (e.code === 'Enter') {
                                                                                         e.preventDefault()
                                                                                         this.checkPromocode(props.values.phone, e.target.value)
                                                                                     }
                                                                                 }
                                                                             }
                                                                      />
                                                                      <button
                                                                        disabled={this.state.sendLoading}
                                                                        onClick={e => {
                                                                            e.preventDefault()
                                                                            this.checkPromocode(props.values.phone, this.state.discountCode)
                                                                        }}
                                                                        className={this.state.discountCode.length > 1 ? 'active' : ''}
                                                                      >
                                                                          {
                                                                              this.state.sendLoading ?
                                                                                <img
                                                                                  src={require('../../static/images/loading-gray.gif')}
                                                                                  alt=""/> :
                                                                                <img
                                                                                  src={require('../../static/images/icons/yes-icon-color.svg').default}
                                                                                  alt=""/>
                                                                          }
                                                                      </button>
                                                                  </div>
                                                                }
                                                                {this.state.showCodeNotFound ?
                                                                  <div className="promocode-not-found">Промокод не действителен</div> : ''}
                                                            </div>
                                                      }
                                                  </div>

                                                  <div className="clientForm__user-data">
                                                      {resultCard.family ? <h3>Контракт №1</h3> : ''}

                                                      <h2>Данные владельца {resultCard.test_drive ? 'разового' : ''} контракта ({resultCard.youth ? '15-18 лет' : (resultCard.test_drive ? '15+' : '18+')})</h2>

                                                      <div className="clientForm__user-data__fields">
                                                          <div className="clientForm__item">
                                                              {
                                                                  (props.touched.name && props.errors.name)
                                                                    ?
                                                                    <span className="error-field">{props.errors.name}</span>
                                                                    : <span className="name-field">ФИО</span>
                                                              }
                                                              <input
                                                                type="text"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.name}
                                                                name="name"
                                                                autoComplete="off"
                                                                className={`
                                                                              ${props.touched.name && props.errors.name && '_error-field'}
                                                                              ${props.touched.name && !props.errors.name && '_valid'}
                                                                            `}
                                                              />
                                                          </div>
                                                          {/*
                                                          <div className="clientForm__item">
                                                              {
                                                                  (props.touched.surname && props.errors.surname)
                                                                    ? <span
                                                                      className="error-field">{props.errors.surname}</span>
                                                                    : <span className="name-field">Фамилия</span>
                                                              }
                                                              <input
                                                                type="text"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.surname}
                                                                name="surname"
                                                                autoComplete="off"
                                                                className={`
                                                                                ${props.touched.surname && props.errors.surname && '_error-field'}
                                                                                ${props.touched.surname && !props.errors.surname && '_valid'}
                                                                            `}
                                                              />
                                                          </div>
                                                          {/*
                                                                <div className="clientForm__item">
                                                                    {
                                                                        (props.touched.patronymic && props.errors.patronymic)
                                                                            ? <span
                                                                                className="error-field">{props.errors.patronymic}</span>
                                                                            : <span className="name-field">Отчество</span>
                                                                    }
                                                                    <input
                                                                        type="text"
                                                                        onChange={props.handleChange}
                                                                        onBlur={props.handleBlur}
                                                                        value={props.values.patronymic}
                                                                        name="patronymic"
                                                                        autoComplete="off"
                                                                        className={`
                                                                              ${props.touched.patronymic && props.errors.patronymic && '_error-field'}
                                                                              ${props.touched.patronymic && !props.errors.patronymic && '_valid'}
                                                                            `}
                                                                    />
                                                                </div>
                                                                */}
                                                          <div className="clientForm__item">
                                                              {
                                                                  (props.touched.phone && props.errors.phone)
                                                                    ? <span className="error-field">{props.errors.phone}</span>
                                                                    : <span className="name-field">Телефон</span>
                                                              }
                                                              <InputMask
                                                                type="text"
                                                                onChange={props.handleChange}
                                                                onBlur={(e) => {
                                                                    this.checkPhone(e.target.value, props.errors.phone === undefined)
                                                                    props.handleBlur(e)
                                                                }}
                                                                name="phone"
                                                                id="phone-field"
                                                                autocomplete="new-password"
                                                                mask="+7 999 999-99-99"
                                                                maskChar=""
                                                                value={props.values.phone}
                                                                className={`
                                                                          ${props.touched.phone && props.errors.phone && '_error-field'}
                                                                          ${props.touched.phone && !props.errors.phone && '_valid'}
                                                                        `}
                                                                inputMode="tel"
                                                              />
                                                              {this.props.resultCard.slug == 'sale' && !(props.touched.phone && !props.errors.phone) ? <span style={{fontWeight: 600, marginTop: '5px'}}>Введите номер телефона, чтобы увидеть свою скидку и стоимость абонемента</span> : ''}
                                                          </div>
                                                          <div className="clientForm__two-columns">
                                                              <div className="clientForm__item">
                                                                  {
                                                                      (props.touched.contact_method && props.errors.contact_method)
                                                                        ? <span className="error-field">{props.errors.contact_method}</span>
                                                                        : <span className="name-field">Как с вами лучше связаться?</span>
                                                                  }
                                                                  <Select
                                                                    options={contactMethods}
                                                                    name="contact_method"
                                                                    value={contactMethods ? contactMethods.find(option => option.value === props.values.contact_method) : ''}
                                                                    onChange={option => {
                                                                        props.setFieldValue('contact_method', option.value)
                                                                    }}
                                                                    onBlur={props.handleBlur}
                                                                    className={`
                                                                          react-select-container
                                                                          ${props.touched.contact_method && props.errors.contact_method && '_error-field'}
                                                                          ${props.touched.contact_method && !props.errors.contact_method && '_valid'}
                                                                        `}
                                                                    classNamePrefix="react-select"
                                                                    placeholder="Выберите способ связи"
                                                                    isSearchable={false}
                                                                    formatOptionLabel={function (data) {
                                                                        return (
                                                                          <span dangerouslySetInnerHTML={{__html: data.label}}/>
                                                                        );
                                                                    }}
                                                                  />
                                                              </div>
                                                              {
                                                                ['telegram', 'max'].includes(props.values.contact_method) &&
                                                                <div className="clientForm__item">
                                                                    {
                                                                        (props.touched.nickname && props.errors.nickname)
                                                                          ?
                                                                          <span className="error-field">{props.errors.nickname}</span>
                                                                          : <span className="name-field">Укажите свой ник для связи</span>
                                                                    }
                                                                    <input
                                                                      type="text"
                                                                      onChange={props.handleChange}
                                                                      onBlur={props.handleBlur}
                                                                      value={props.values.nickname}
                                                                      name="nickname"
                                                                      autoComplete="off"
                                                                      className={`
                                                                          ${props.touched.nickname && props.errors.nickname && '_error-field'}
                                                                          ${props.touched.nickname && !props.errors.nickname && '_valid'}
                                                                      `}
                                                                    />
                                                                </div>
                                                              }
                                                          </div>
                                                          <div className="clientForm__item">
                                                              {
                                                                  (props.touched.email && props.errors.email)
                                                                    ? <span className="error-field">{props.errors.email}</span>
                                                                    : <span className="name-field">E-mail</span>
                                                              }
                                                              <input
                                                                type="text"
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={props.values.email}
                                                                name="email"
                                                                autoComplete="off"
                                                                className={`
                                                                          ${props.touched.email && props.errors.email && '_error-field'}
                                                                          ${props.touched.email && !props.errors.email && '_valid'}
                                                                        `}
                                                              />
                                                          </div>
                                                          <div className="clientForm__two-columns">
                                                              <div className="clientForm__item">
                                                                  {
                                                                      (props.touched.birthDate && props.errors.birthDate)
                                                                        ? <span
                                                                          className="error-field">{props.errors.birthDate}</span>
                                                                        :
                                                                        <span className="name-field">Дата рождения</span>
                                                                  }
                                                                  <InputMask
                                                                    type="text"
                                                                    onChange={props.handleChange}
                                                                    onBlur={props.handleBlur}
                                                                    name="birthDate"
                                                                    id="birthdate-field"
                                                                    autoComplete="off"
                                                                    mask='39.19.2999'
                                                                    maskChar=""
                                                                    formatChars={{
                                                                        '1': '[0-1]',
                                                                        '2': '[0-2]',
                                                                        '3': '[0-3]',
                                                                        '9': '[0-9]',
                                                                    }}
                                                                    value={props.values.birthDate}
                                                                    className={`
                                                                              ${props.touched.birthDate && props.errors.birthDate && '_error-field'}
                                                                              ${props.touched.birthDate && !props.errors.birthDate && '_valid'}
                                                                            `}
                                                                    inputMode="numeric"
                                                                  />
                                                              </div>
                                                              {
                                                                  this.state.activationDateRequired ?
                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.activationDate && props.errors.activationDate)
                                                                              ? <span
                                                                                className="error-field">{props.errors.activationDate}</span>
                                                                              :
                                                                              <span className="name-field">Дата начала оказания услуг</span>
                                                                        }
                                                                        <DatePicker
                                                                          dateFormat="dd.MM.yyyy"
                                                                          selected={props.values.activationDate}
                                                                          className={`
                                                                                  ${props.touched.activationDate && props.errors.activationDate && '_error-field'}
                                                                                  ${props.touched.activationDate && !props.errors.activationDate && '_valid'}
                                                                                `}
                                                                          onChange={date => props.setFieldValue('activationDate', date)}
                                                                          includeDateIntervals={[
                                                                              {
                                                                                  start: subHours(new Date(), 24),
                                                                                  end: addDays(new Date(), parseInt(this.props.resultCard.max_activation_days_delay))
                                                                              },
                                                                          ]}
                                                                          customInput={<CalendarCustomInput/>}
                                                                          placeholder="Выберите дату"
                                                                        />
                                                                    </div> : ''
                                                              }
                                                          </div>
                                                          {
                                                              this.props.resultCard.slug == 'light' ?
                                                                  <div className="clientForm__item">
                                                                      {
                                                                          (props.touched.sex && props.errors.sex)
                                                                            ? <span className="error-field">{props.errors.sex}</span>
                                                                            : <span className="name-field">Пол</span>
                                                                      }
                                                                      <Select
                                                                        options={[
                                                                            {
                                                                                value: 'М',
                                                                                label: 'Мужской'
                                                                            },
                                                                            {
                                                                                value: 'Ж',
                                                                                label: 'Женский'
                                                                            }
                                                                        ]}
                                                                        name="sex"
                                                                        onChange={option => {
                                                                            props.setFieldValue('sex', option.value)
                                                                        }}
                                                                        onBlur={props.handleBlur}
                                                                        className={`
                                                                                  react-select-container
                                                                                  ${props.touched.sex && props.errors.sex && '_error-field'}
                                                                                  ${props.touched.sex && !props.errors.sex && '_valid'}
                                                                                `}
                                                                        classNamePrefix="react-select"
                                                                        placeholder="Выберите пол"
                                                                        isSearchable={false}
                                                                        formatOptionLabel={function (data) {
                                                                            return (
                                                                              <span dangerouslySetInnerHTML={{__html: data.label}}/>
                                                                            );
                                                                        }}
                                                                      />
                                                                  </div> : ''
                                                          }
                                                          <div className="clientForm__item">
                                                              {
                                                                  (props.touched.club && props.errors.club)
                                                                    ? <span className="error-field">{props.errors.club}</span>
                                                                    : <span className="name-field">Начну тренировки в</span>
                                                              }
                                                              <Select
                                                                options={clubOptions}
                                                                name="club"
                                                                value={clubOptions ? clubOptions.find(option => option.value === props.values.club) : ''}
                                                                onChange={option => {
                                                                    props.setFieldValue('club', option.value)
                                                                }}
                                                                onBlur={props.handleBlur}
                                                                className={`
                                                                          react-select-container
                                                                          ${props.touched.club && props.errors.club && '_error-field'}
                                                                          ${props.touched.club && !props.errors.club && '_valid'}
                                                                        `}
                                                                classNamePrefix="react-select"
                                                                placeholder="Выберите адрес"
                                                                isSearchable={false}
                                                                formatOptionLabel={function (data) {
                                                                    return (
                                                                      <span dangerouslySetInnerHTML={{__html: data.label}}/>
                                                                    );
                                                                }}
                                                              />
                                                          </div>

                                                          {
                                                              resultCard.family ?
                                                                <div className="clientForm__secondContragent">
                                                                    <h3>Контракт №2</h3>

                                                                    <h2>Укажите данные владельца {resultCard.test_drive ? 'разового' : ''} контракта (11+)</h2>

                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.secondName && props.errors.secondName)
                                                                              ?
                                                                              <span
                                                                                className="error-field">{props.errors.secondName}</span>
                                                                              : <span className="name-field">ФИО</span>
                                                                        }
                                                                        <input
                                                                          type="text"
                                                                          onChange={props.handleChange}
                                                                          onBlur={props.handleBlur}
                                                                          value={props.values.secondName}
                                                                          name="secondName"
                                                                          autoComplete="off"
                                                                          className={`
                                                                              ${props.touched.secondName && props.errors.secondName && '_error-field'}
                                                                              ${props.touched.secondName && !props.errors.secondName && '_valid'}
                                                                            `}
                                                                        />
                                                                    </div>
                                                                    {/*
                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.secondSurname && props.errors.secondSurname)
                                                                              ? <span
                                                                                className="error-field">{props.errors.secondSurname}</span>
                                                                              : <span className="name-field">Фамилия</span>
                                                                        }
                                                                        <input
                                                                          type="text"
                                                                          onChange={props.handleChange}
                                                                          onBlur={props.handleBlur}
                                                                          value={props.values.secondSurname}
                                                                          name="secondSurname"
                                                                          autoComplete="off"
                                                                          className={`
                                                                                ${props.touched.secondSurname && props.errors.secondSurname && '_error-field'}
                                                                                ${props.touched.secondSurname && !props.errors.secondSurname && '_valid'}
                                                                            `}
                                                                        />
                                                                    </div>
                                                                    */}
                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.secondPhone && props.errors.secondPhone)
                                                                              ? <span
                                                                                className="error-field">{props.errors.secondPhone}</span>
                                                                              :
                                                                              <span className="name-field">Номер телефона</span>
                                                                        }
                                                                        <InputMask
                                                                          type="text"
                                                                          onChange={props.handleChange}
                                                                          onBlur={(e) => {
                                                                              this.checkPhone(e.target.value, props.errors.secondPhone === undefined, true)
                                                                              props.handleBlur(e)
                                                                          }}
                                                                          name="secondPhone"
                                                                          id="secondPhone-field"
                                                                          autocomplete="new-password"
                                                                          mask="+7 999 999-99-99"
                                                                          maskChar=""
                                                                          value={props.values.secondPhone}
                                                                          className={`
                                                                              ${props.touched.secondPhone && props.errors.secondPhone && '_error-field'}
                                                                              ${props.touched.secondPhone && !props.errors.secondPhone && '_valid'}
                                                                          `}
                                                                        />
                                                                    </div>
                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.secondEmail && props.errors.secondEmail)
                                                                              ? <span
                                                                                className="error-field">{props.errors.secondEmail}</span>
                                                                              : <span className="name-field">E-mail</span>
                                                                        }
                                                                        <input
                                                                          type="text"
                                                                          onChange={props.handleChange}
                                                                          onBlur={props.handleBlur}
                                                                          value={props.values.secondEmail}
                                                                          name="secondEmail"
                                                                          autoComplete="off"
                                                                          className={`
                                                                              ${props.touched.secondEmail && props.errors.secondEmail && '_error-field'}
                                                                              ${props.touched.secondEmail && !props.errors.secondEmail && '_valid'}
                                                                          `}
                                                                        />
                                                                    </div>
                                                                    <div className="clientForm__two-columns">
                                                                        <div className="clientForm__item">
                                                                            {
                                                                                (props.touched.secondBirthDate && props.errors.secondBirthDate)
                                                                                  ? <span
                                                                                    className="error-field">{props.errors.secondBirthDate}</span>
                                                                                  :
                                                                                  <span className="name-field">Дата рождения</span>
                                                                            }
                                                                            <InputMask
                                                                              type="text"
                                                                              onChange={props.handleChange}
                                                                              onBlur={(e) => {
                                                                                  this.setState({
                                                                                      secondCardIsTeen: !this.checkMinAge(e.target.value, 18)
                                                                                  })
                                                                                  props.handleBlur(e)
                                                                              }}
                                                                              name="secondBirthDate"
                                                                              id="secondBirthDate-field"
                                                                              autoComplete="off"
                                                                              mask='39.19.2999'
                                                                              maskChar=""
                                                                              formatChars={{
                                                                                  '1': '[0-1]',
                                                                                  '2': '[0-2]',
                                                                                  '3': '[0-3]',
                                                                                  '9': '[0-9]',
                                                                              }}
                                                                              value={props.values.secondBirthDate}
                                                                              className={`
                                                                                  ${props.touched.secondBirthDate && props.errors.secondBirthDate && '_error-field'}
                                                                                  ${props.touched.secondBirthDate && !props.errors.secondBirthDate && '_valid'}
                                                                              `}
                                                                              inputMode="numeric"
                                                                            />
                                                                        </div>
                                                                        {
                                                                            this.state.secondActivationDateRequired ?
                                                                              <div className="clientForm__item">
                                                                                  {
                                                                                      (props.touched.secondActivationDate && props.errors.secondActivationDate)
                                                                                        ? <span
                                                                                          className="error-field">{props.errors.secondActivationDate}</span>
                                                                                        : <span
                                                                                          className="name-field">Начало тренировок</span>
                                                                                  }
                                                                                  <DatePicker
                                                                                    dateFormat="dd.MM.yyyy"
                                                                                    selected={props.values.secondActivationDate}
                                                                                    className={`
                                                                                          ${props.touched.secondActivationDate && props.errors.secondActivationDate && '_error-field'}
                                                                                          ${props.touched.secondActivationDate && !props.errors.secondActivationDate && '_valid'}
                                                                                        `}
                                                                                    onChange={date => props.setFieldValue('secondActivationDate', date)}
                                                                                    includeDateIntervals={[
                                                                                        {
                                                                                            start: new Date(),
                                                                                            end: addDays(new Date(), parseInt(this.props.resultCard.max_activation_days_delay))
                                                                                        },
                                                                                    ]}
                                                                                    customInput={<CalendarCustomInput/>}
                                                                                  />
                                                                              </div> : ''
                                                                        }
                                                                    </div>
                                                                </div> : ''
                                                          }

                                                          {
                                                              resultCard.test_drive ?
                                                                <div>
                                                                    <div className="clientForm__item _radio">
                                                                        {
                                                                            (props.touched.withTrainer && props.errors.withTrainer)
                                                                              ? <span
                                                                                className="error-field">{props.errors.withTrainer}</span>
                                                                              : ''
                                                                        }
                                                                        <label>
                                                                            <Field type="radio" hidden name="withTrainer"
                                                                                   value="1"/>
                                                                            <span></span>
                                                                            <p>с тренером</p>
                                                                        </label>
                                                                        <label>
                                                                            <Field type="radio" hidden name="withTrainer"
                                                                                   value="0"/>
                                                                            <span></span>
                                                                            <p>без тренера</p>
                                                                        </label>
                                                                    </div>

                                                                    {
                                                                        props.values.withTrainer == 1 ?
                                                                          <div className="with-trainer-warning">
                                                                              Услуга оказывается только при предварительной записи через отдел продаж - обратитесь в отдел продаж!
                                                                          </div> : ''
                                                                    }

                                                                    <div className="clientForm__item">
                                                                        {
                                                                            (props.touched.visitTime && props.errors.visitTime)
                                                                              ? <span
                                                                                className="error-field">{props.errors.visitTime}</span>
                                                                              : ''
                                                                        }
                                                                        <div className="_visit-time-radio">
                                                                            <label>
                                                                                <Field type="radio" hidden name="visitTime" value="1"/>
                                                                                <p>6:00-9:00</p>
                                                                            </label>
                                                                            <label>
                                                                                <Field type="radio" hidden name="visitTime" value="2"/>
                                                                                <p>9:00-21:00</p>
                                                                            </label>
                                                                            <label>
                                                                                <Field type="radio" hidden name="visitTime" value="3"/>
                                                                                <p>21:00-23:00</p>
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        props.values.visitTime == 1 || props.values.visitTime == 3 ?
                                                                          <div className="visit-time-warning">
                                                                              <div className="alert-text">Самостоятельный доступ
                                                                                  в клуб
                                                                              </div>
                                                                              <div className="info-text">Менеджеры отдела продаж
                                                                                  работают с <b>9:00</b> до <b>21:00</b>.
                                                                                  Если вам будет необходима помощь или
                                                                                  консультация в клубе, рекомендуем вам сменить
                                                                                  время посещения.
                                                                              </div>
                                                                          </div> : ''
                                                                    }
                                                                </div> :
                                                                ''
                                                          }

                                                          <div className="clientForm__item _checkbox">
                                                              {
                                                                  this.state.agreementError
                                                                    ? <span
                                                                      className="error-field">{this.state.agreementErrorText}</span>
                                                                    : null
                                                              }
                                                              <label>
                                                                  <input
                                                                    type="checkbox"
                                                                    hidden
                                                                    onChange={() => this.handleAgreementProcessData()}
                                                                    checked={this.state.agreement}
                                                                  />
                                                                  <span
                                                                    className={this.state.agreementError ? 'error' : ''}></span>
                                                                  <p>Нажимая на кнопку, Вы даёте&nbsp;
                                                                      <a href={this.props.documents?.['process-personal-data-agreement.pdf']?.url} target="_blank" rel="nofollow noopener">согласие на&nbsp;обработку персональных данных</a>
                                                                  </p>
                                                              </label>
                                                          </div>
                                                          <div className="clientForm__item _checkbox">
                                                              {
                                                                  this.state.policyError
                                                                      ? <span
                                                                          className="error-field">{this.state.policyErrorText}</span>
                                                                      : null
                                                              }
                                                              <label>
                                                                  <input
                                                                      type="checkbox"
                                                                      hidden
                                                                      onChange={() => this.handleAgreementPolicy()}
                                                                      checked={this.state.policy}
                                                                  />
                                                                  <span
                                                                      className={this.state.policyError ? 'error' : ''}></span>
                                                                  <p>Нажимая на&nbsp;кнопку, Вы&nbsp;соглашаетесь&nbsp;c&nbsp;
                                                                      <a href={this.props.documents?.['politics-confidential.pdf']?.url}
                                                                         target="_blank"
                                                                         rel="noopener noreferrer">политикой обработки персональных данных</a> и&nbsp;
                                                                      <a href={this.props.documents?.['user-agreement.pdf']?.url}
                                                                         target="_blank"
                                                                         rel="noopener noreferrer">пользовательским соглашением</a>
                                                                  </p>
                                                              </label>
                                                          </div>
                                                          <div className="clientForm__item _checkbox">
                                                              {
                                                                  this.state.ofertaError
                                                                    ? <span
                                                                      className="error-field">{this.state.ofertaErrorText}</span>
                                                                    : null
                                                              }
                                                              <label>
                                                                  <input
                                                                    type="checkbox"
                                                                    hidden
                                                                    onChange={() => this.handleAgreementOferta()}
                                                                    checked={this.state.oferta}
                                                                  />
                                                                  <span
                                                                    className={this.state.ofertaError ? 'error' : ''}></span>
                                                                  <p>Нажимая на&nbsp;кнопку, Вы&nbsp;соглашаетесь с&nbsp;{resultCard.subscription ? 'подпиской согласно ' : ''}<a
                                                                    href={resultCard.subscription ? this.props.documents?.['kf16_ip_pluzhnikov_podpiska.pdf']?.url : this.props.documents?.['oferta-ip-pluzhnikov-online.pdf']?.url}
                                                                    target="_blank" rel="noopener noreferrer">условиям{resultCard.subscription ? '' : 'и'} оферты</a>, <a href={this.props.documents?.['oferta_regular_payments.pdf']?.url}
                                                                    target="_blank" rel="noopener noreferrer">соглашением о регулярных платежах</a>, <a href={this.props.documents?.['pravila-tehniki-bezopasnosti.pdf']?.url} target="_blank" rel="noopener noreferrer">правилами техники безопасности</a> и&nbsp;<a
                                                                    href="https://fitron.club/club-rules/" target="_blank"
                                                                    rel="nofollow">правилами клуба</a></p>
                                                              </label>
                                                          </div>
                                                          <div className="clientForm__item _checkbox">
                                                              {
                                                                  this.state.callConsentError
                                                                      ? <span
                                                                          className="error-field">{this.state.callConsentErrorText}</span>
                                                                      : null
                                                              }
                                                              <label>
                                                                  <input
                                                                      type="checkbox"
                                                                      hidden
                                                                      onChange={() => this.handleCallConsent()}
                                                                      checked={this.state.callConsent}
                                                                  />
                                                                  <span className={this.state.callConsentError ? 'error' : ''}></span>
                                                                  <p>Даю согласие и разрешение связаться со мной по телефону, с помощью СМС или e-mail.</p>
                                                              </label>
                                                          </div>
                                                          <div className="clientForm__item _checkbox">
                                                              {
                                                                  this.state.mailingError
                                                                      ? <span
                                                                          className="error-field">{this.state.mailingErrorText}</span>
                                                                      : null
                                                              }
                                                              <label>
                                                                  <input
                                                                      type="checkbox"
                                                                      hidden
                                                                      onChange={() => this.handleMailing()}
                                                                      checked={this.state.mailing}
                                                                  />
                                                                  <span className={this.state.mailingError ? 'error' : ''}></span>
                                                                  <p>Даю <a href={this.props.documents?.['advertising-and-information-mailing-agreement.pdf']?.url} rel="nofollow noopener" target="_blank">согласие</a> на получение рассылки рекламно-информационных материалов.</p>
                                                              </label>
                                                          </div>
                                                          {
                                                              studentStatus && resultCard.student_discount ?
                                                                <div className="clientForm__item _checkbox">
                                                                    {
                                                                        this.state.studentConfirmError
                                                                          ? <span
                                                                            className="error-field">{this.state.studentConfirmErrorText}</span>
                                                                          : null
                                                                    }
                                                                    <label>
                                                                        <input
                                                                          type="checkbox"
                                                                          hidden
                                                                          onClick={() => this.handleConfirmStudent()}
                                                                        />
                                                                        <span
                                                                          className={this.state.studentConfirmError ? 'error' : ''}></span>
                                                                        <p>Подтверждаю наличие студенческого билета и соглашаюсь
                                                                            предъявить его при оформлении контракта</p>
                                                                    </label>
                                                                </div>
                                                                : ''
                                                          }
                                                          <p className="passport-warning">Сеть фитнес-клубов Fitron входит в перечень организаций, оказывающих физкультурно-оздоровительные услуги, по расходам на которые можно получить налоговый вычет в размере 13%</p>
                                                      </div>
                                                  </div>

                                                  <div className="clientForm__send">
                                                      <div className="clientForm__send__btn">
                                                          <button type="submit"
                                                                  className={this.state.sendLoading ? '_loading' : ''}
                                                                  disabled={this.state.sendLoading}>
                                                              <span>Перейти к покупке</span>
                                                          </button>
                                                      </div>

                                                      <p className="passport-warning">Сеть фитнес-клубов Fitron входит в перечень организаций, оказывающих физкультурно-оздоровительные услуги, по расходам на которые можно получить налоговый вычет в размере 13%</p>

                                                      <Privileges
                                                        privileges={resultCard.privileges}
                                                        milleniumAdded={milleniumAdded || resultCard.clubs.millenium}
                                                        millenium_privileges={resultCard.millenium_privileges}
                                                        towel={resultCard.test_drive && resultCard.includes.towel}
                                                        testDrive={resultCard.test_drive}
                                                        family={resultCard.family}
                                                        subscription={resultCard.subscription}
                                                      ></Privileges>
                                                  </div>
                                              </form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                          : <div className="offers__loading">
                              <img src={require('../../static/images/loading.gif')} alt=""/>
                          </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mainData: state.card.mainData,
        resultCard: state.card.resultCard,
        prolongation: state.card.prolongation,
        prolongationDiscount: state.card.prolongationDiscount,
        installmentDiscount: state.card.installmentDiscount,
        studentStatus: state.card.studentStatus,
        dayDiscount: state.card.dayDiscount,
        clubOferta: state.card.clubOferta,
        promocode: state.card.promocode,
        milleniumAdded: state.card.milleniumAdded && state.card.resultCard.millenium_add_available,
        gameleadDiscount: state.card.gameleadDiscount,
        gameleadPresent: state.card.gameleadPresent,
        widgetDiscount: state.card.widgetDiscount,
        widgetPresent: state.card.widgetPresent,
        duration: state.card.duration,
        freezing: state.card.freezing,
        customerData: state.card.customerData,
        documents: state.documents?.documents,
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    openModal,
    changeTypeOfModal,
    saveModalInfo,
    setCustomerData,
    setProlongation,
    setGameleadDiscount,
    setGameleadPresent,
    setWidgetDiscount,
    setWidgetPresent,
    setPromocode,
    switchMilleniumClub,
    setResultCard,
    eventSelectCard,
    setStudentStatus,
    switchInstallmentDiscount,
    setOrderCode
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormBlock);
